import {
    Component,
    ChangeDetectionStrategy,
    ViewEncapsulation
} from '@angular/core';

@Component({
    selector: 'ihd-loader',
    templateUrl: 'loader.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    styleUrls: [
        './loader.component.scss'
    ],
    host: {
        class: 'c-loader'
    }
})
export class LoaderComponent {

}
